import {
  MainLayout,
  BlankLayout
} from '../layout';
import login from '@/page/login';

const constantRouterMap = [{
    path: '/',
    alias: '/login',
    name: 'home',
    meta: {
      requireAuth: false,
    },
    component: login
  },
  {
    path: '/MainLayout',
    name: 'MainLayout',
    meta: {
      title: 'MainLayout',
    },
    component: MainLayout,
    children: [{
        path: '/register',
        name: 'register',
        meta: {
          requireAuth: false,
        },
        component: () => import('@/page/register')
      },
      {
        path: '/supplementStudentInfo',
        name: 'supplementStudentInfo',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/supplementStudentInfo')
      },
      {
        path: '/pendingContracts',
        name: 'pendingContracts',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/pendingContracts')
      },
      {
        path: '/reviewing',
        name: 'reviewing',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/reviewing')
      }, {
        path: '/courseCount',
        name: 'courseCount',
        meta: {
          requireAuth: true,
          requireEnable: true
        },
        component: () => import('@/page/courseCount')
      }, {
        path: '/courseSchedule',
        name: 'courseSchedule',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/courseSchedule')
      }, {
        path: '/studentProfile',
        name: 'studentProfile',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/studentProfile')
      },
      {
        path: '/studentDisable',
        name: 'studentDisable',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/studentDisable'),
      },
      {
        path: '/studentEmailValidation',
        name: 'studentEmailValidation',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/studentEmailValidation'),
      },
      {
        path: '/admin/login',
        alias: '/admin',
        name: 'adminLogin',
        meta: {
          requireAuth: false,
        },
        component: () => import('@/page/admin/login')
      },
      {
        path: '/admin/studentList',
        name: 'adminStudentList',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/studentList')
      },
      {
        path: '/admin/studentCourseSuggestionList',
        name: 'adminStudentCourseSuggestionList',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/studentCourseSuggestionList')
      },
      {
        path: '/admin/studentVipCourseRecordList',
        name: 'adminStudentVipCourseRecordList',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/studentVipCourseRecordList')
      },
      {
        path: '/admin/porfile',
        name: 'adminProfile',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/profile')
      },
      {
        path: '/admin/speedupCourseSchedule',
        name: 'adminSpeedupCourseSchedule',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/speedupCourseSchedule')
      },
      {
        path: '/admin/speedupCourseList',
        name: 'adminSpeedupCourseList',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/speedupCourseList')
      },
      {
        path: '/admin/termManagement',
        name: 'adminTermManagement',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/termManagement')
      },
      {
        path: '/frontDesk/courseApply',
        name: 'frontDeskCourseApply',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/frontDesk/courseApply')
      },
      {
        path: '/admin/bonusPointMechanism',
        name: 'adminBonusPointMechanism',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/bonusPointMechanism')
      },
      {
        path: '/admin/priceManagement',
        name: 'adminPriceManagement',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/priceManagement')
      },
      {
        path: '/admin/signInManage',
        name: 'adminSignInManage',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/signInManage')
      },
      {
        path: '/admin/signInQuery',
        name: 'adminSignInQuery',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/signInQuery')
      },
      {
        path: '/admin/signInManageEdit',
        name: 'adminSignInManageEdit',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/signInManageEdit')
      },
      {
        path: '/admin/accountManage',
        name: 'adminAccountManage',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/accountManage')
      },
      {
        path: '/admin/logList',
        name: 'adminLogList',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/logList')
      },
      {
        path: '/teacher/schedule',
        name: 'teacherSchedule',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/teacher/schedule')
      },
      {
        path: '/teacher/activateCourse',
        name: 'teacherActivateCourse',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/teacher/activateCourse')
      },
      {
        path: '/teacher/signInManageView',
        name: 'teacherSignInManageView',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/teacher/signInManageView')
      },
      {
        path: '/teacher/emailVideoList',
        name: 'teacherEmailVideoList',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/teacher/emailVideoList')
      },
      {
        path: '/signCourse',
        name: 'studentSignCourse',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/signCourse')
      },
      {
        path: '/signDetail',
        name: 'studentSignCourseDetail',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/signDetail')
      },
      {
        path: '/finance/accountList',
        name: 'financeAccountList',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/finance/accountList')
      },
      {
        path: '/addCollectFees/advanceEnrollmentFee',
        name: 'addCollectFeesAdvanceEnrollmentFee',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/addCollectFees/advanceEnrollmentFee')
      },
      {
        path: '/addCollectFees/courseEnrollmentFee',
        name: 'addCollectFeesCourseEnrollmentFee',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/addCollectFees/courseEnrollmentFee')
      },
      {
        path: '/addCollectFees/topUpBalance',
        name: 'addCollectFeesTopUpBalance',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/addCollectFees/otherCollectFee')
      },
      {
        path: '/addCollectFees/otherCollectFee',
        name: 'addCollectFeesOtherCollectFee',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/addCollectFees/otherCollectFee')
      },
      {
        path: '/addCollectFees/autonomousList',
        name: 'addCollectFeesAutonomousList',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/addCollectFees/autonomousList')
      },
      {
        path: '/addCollectFees/freeTrialList',
        name: 'addCollectFeesFreeTrialList',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/addCollectFees/freeTrialList')
      },
      {
        path: '/finance/discountManage',
        name: 'financeDiscountManage',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/finance/discountManage')
      },
      {
        path: '/frontDesk/priceQuery',
        name: 'frontDeskPriceQuery',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/frontDesk/priceQuery')
      },
      {
        path: '/frontDesk/salesQuery',
        name: 'frontDeskSalesQuery',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/frontDesk/salesQuery')
      },
      {
        path: '/frontDesk/salesQueryContinuePayment',
        name: 'frontDeskSalesQueryContinuePayment',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/frontDesk/salesQueryContinuePayment')
      },
      {
        path: '/admin/bpeItemManagement',
        name: 'adminBPEItemManagement',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/bpeItemManagement')
      },
      {
        path: '/admin/universityList',
        name: 'adminUniversityList',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/universityList')
      },
      {
        path: '/admin/campusList',
        name: 'adminCampusList',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/campusList')
      },
      {
        path: '/admin/performanceEvaluation',
        name: 'adminPerformanceEvaluation',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/performanceEvaluation')
      },
      {
        path: '/admin/computerList',
        name: 'adminComputerList',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/computerList')
      },
      {
        path: '/videoAppointmentList',
        name: 'videoAppointmentList',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/videoAppointmentList')
      },
      {
        path: '/admin/schoolHotList',
        name: 'adminSchoolHotList',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/schoolHotList')
      },
      {
        path: '/admin/advertistingList',
        name: 'adminAdvertistingList',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/advertistings/advertistingList')
      },
      {
        path: '/admin/studentAdvertisement',
        name: 'studentAdvertisement',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/studentAdvertisement')
      },
      {
        path: '/homeworkManage',
        name: 'homeworkManage',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/homework/homeworkManage')
      },
      {
        path: '/homeworkList',
        name: 'homeworkList',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/homework/homeworkList')
      },
      {
        path: '/homeworkStudentList',
        name: 'homeworkStudentList',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/homework/homeworkStudentList')
      },
      {
        path: '/studentHomeworkDetail',
        name: 'studentHomeworkDetail',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/homework/studentHomeworkDetail')
      },
      {
        path: '/coursewareManagement',
        name: 'coursewareManagement',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/courseware/coursewareManagement')
      },
      {
        path: '/coursewareWeekly',
        name: 'coursewareWeekly',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/courseware/coursewareWeekly')
      },
      {
        path: '/coursewareFiles',
        name: 'coursewareFiles',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/courseware/coursewareFiles')
      },
      {
        path: '/studentLanding',
        name: 'studentLanding',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/studentLanding')
      },
      {
        path: '/openCourseList',
        name: 'openCourseList',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/openCourseList')
      },
      {
        path: '/autonomousEnrolment',
        name: 'autonomousEnrolment',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/addCollectFees/autonomousEnrolment')
      },
      {
        path: '/studyAbroad/channelList',
        name: 'studyAbroadChannelList',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/studyAbroad/channelList')
      },
      {
        path: '/studyAbroad/studentList',
        name: 'studyAbroadStudentList',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/studyAbroad/studentList')
      },
      {
        path: '/studyAbroad/studentServiceList',
        name: 'studyAbroadStudentServiceList',
        meta: {
          requireAuth: true,
          menuActive: '/studyAbroad/studentList',
          navName: '真留服务列表'
        },
        component: () => import('@/page/studyAbroad/studentServiceList')
      },
      {
        path: '/saServiceList',
        name: 'saServiceList',
        meta: {
          requireAuth: true,
          menuActive: '/saServiceList',
          navName: '真留计划项目'
        },
        component: () => import('@/page/studyAbroad/studentServiceList')
      },
      {
        path: '/studyAbroad/studentServiceDetail',
        name: 'studyAbroadStudentServiceDetail',
        meta: {
          requireAuth: true,
          menuActive: '/studyAbroad/studentList'
        },
        component: () => import('@/page/studyAbroad/studentServiceDetail')
      },
      {
        path: '/studyAbroad/runningAccount',
        name: 'studyAbroadRunningAccount',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/studyAbroad/runningAccount')
      },
      {
        path: '/studyAbroad/accountDetail',
        name: 'studyAbroadAccountDetail',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/studyAbroad/accountDetail')
      },
      {
        path: '/studyAbroad/accountList',
        name: 'studyAbroadAccountList',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/studyAbroad/accountList')
      },
      {
        path: '/studyAbroad/taskAssignment',
        name: 'studyAbroadTaskAssignment',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/studyAbroad/taskAssignment')
      },
      {
        path: '/studyAbroad/taskAssignmentDetail',
        name: 'studyAbroadTaskAssignmentDetail',
        meta: {
          requireAuth: true,
          navName: '分配详情'
        },
        component: () => import('@/page/studyAbroad/taskAssignmentDetail')
      },
      {
        path: '/admin/contractList',
        name: 'contractList',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/contractList')
      },
      {
        path: '/admin/studentDevice',
        name: 'studentDevice',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/studentDevice')
      },
      {
        path: '/studyAbroad/studentInfoList',
        name: 'studyAbroadStudentInfoList',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/studyAbroad/studentInfoList')
      },
      {
        path: '/studyAbroad/salesQuery',
        name: 'studyAbroadSalesQuery',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/studyAbroad/salesQuery')
      },
      {
        path: '/admin/orgChart',
        name: "adminOrgChart",
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/orgChart')
      },
      {
        path: '/admin/studentScoreCollection',
        name: "adminStudentScoreCollection",
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/studentScoreCollection')
      },
      {
        path: '/universityScoreLockList',
        name: "universityScoreLockList",
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/universityScoreLockList')
      },
      {
        path: '/studentSearch',
        name: "studentSearch",
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/admin/studentSearch')
      },
      {
        path: '/questionnaire/questionnaireList',
        name: 'questionnaireList',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/questionnaire/questionnaireList')
      },
      {
        path: '/questionnaire/questionnaireQuestionList',
        name: 'questionnaireQuestionList',
        meta: {
          requireAuth: true,
          menuActive: '/questionnaire/questionnaireList',
          navName: '问题列表'
        },
        component: () => import('@/page/questionnaire/questionnaireQuestionList')
      },
    ]
  },
  {
    path: '/BlankLayout',
    name: 'BlankLayout',
    meta: {
      title: 'BlankLayout',
    },
    component: BlankLayout,
    children: [{
        path: '/wechatHandler',
        name: 'wechatHandler',
        meta: {
          requireAuth: false,
        },
        component: () => import('@/page/wechat/wechatHandler')
      },
      {
        path: '/wechatResponse',
        name: 'wechatResponse',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/wechat/wechatResponse')
      },
      {
        path: '/payApi/checkpayPaymentResponse',
        name: 'checkpayPaymentResponse',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/payApi/checkpayPaymentResponse')
      },
      {
        path: '/payApi/alphaPayPaymentResponse',
        name: 'alphaPayPaymentResponse',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/payApi/alphaPayPaymentResponse')
      },
      {
        path: '/stripe/response',
        name: 'stripeResponse',
        meta: {
          requireAuth: true,
        },
        component: () => import('@/page/stripe/response')
      },
    ]
  }
];

if (window.AppSettings.IsTestMode) {
  let routerOption = constantRouterMap.find(item => item.name === "MainLayout");
  if (!!routerOption) {
    routerOption.children.push({
      path: '/admin/test',
      name: 'adminTest',
      meta: {
        requireAuth: true,
      },
      component: () => import('@/page/admin/test')
    });
  }
}

export {
  constantRouterMap
};



// WEBPACK FOOTER //
// ./src/config/router.config.js